<template>
  <div
    class="o-select-day-calendar"
    :class="subClass"
  >
    <div class="o-select-day-calendar__main-slot">
      <slot />
    </div>
    <div class="o-select-day-calendar__header">
      <div
        v-for="daysOfWeekName in daysOfWeekNames"
        :key="`day-of-week-${daysOfWeekName}`"
        class="o-select-day-calendar__day-name"
      >
        {{ daysOfWeekName }}
      </div>
    </div>
    <div class="o-select-day-calendar__body">
      <div
        v-for="calendarDay in calendarDays"
        :key="`calendar-day-${calendarDay.date}`"
        class="o-select-day-calendar__day-number"
        :class="{
          'active': calendarDay.active,
          'current': showCurrentDeliveryDate && getCurrentDeliveryDate.date === calendarDay.date,
          'new': getNewDeliveryDate.date === calendarDay.date,
          'current-day': isCurrentDate(calendarDay),
          'no-active': !canChangeDay,
        }"
        @click="selectNewDate(calendarDay)"
      >
        {{ formatDate(calendarDay.date, 'D') }}
      </div>
    </div>
    <div class="o-select-day-calendar__footer-slot">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectDayCalendar',

  props: {
    /**
     * @description Отображение текущей даты доставки на календаре
     */
    showCurrentDeliveryDate: {
      type: Boolean,
      default: false,
    },

    /**
     * @description Отображение текущего дня на календаре
     */
    showCurrentDate: {
      type: Boolean,
      default: false,
    },

    /**
     * @description блокировка возможности смены даты
     */
    canChangeDay: {
      type: Boolean,
      default: true,
    },

    calendarDays: {
      type: Array,
      required: true,
    },
    currentDeliveryDate: {
      type: Object,
      required: true,
    },
    newDeliveryDate: {
      type: Object,
      required: true,
    },
    subClass: {
      type: String,
      default: '',
    },
  },

  emits: [
    'selectNewDate',
  ],

  data () {
    return {
      daysOfWeekNames: [
        'пн',
        'вт',
        'ср',
        'чт',
        'пт',
        'сб',
        'вс',
      ],
    }
  },

  computed: {
    getCurrentDeliveryDate () {
      const {
        date = '',
        timeFrom = '',
        timeTo = '',
        type = '',
      } = this.currentDeliveryDate

      return {
        date,
        timeFrom,
        timeTo,
        type,
      }
    },

    getNewDeliveryDate () {
      const {
        date = '',
        timeFrom = '',
        timeTo = '',
        type = '',
      } = this.newDeliveryDate

      return {
        date,
        timeFrom,
        timeTo,
        type,
      }
    },
  },

  methods: {
    isCurrentDate (data) {
      return this.showCurrentDate && this.$date().format('YYYY-MM-DD') === data.date
    },

    formatDate (date, format) {
      return this.$date(date).format(format)
    },

    selectNewDate (value) {
      if (!this.canChangeDay) {
        return
      }

      if (value.active) {
        if (this.getCurrentDeliveryDate.date === value.date) {
          this.$emit('selectNewDate', value)
        } else {
          this.$emit('selectNewDate', value)
        }
      }
    },
  },
}
</script>

<style lang="scss">
  $prefix: 'o-select-day-calendar';

  .#{$prefix} {
    width: 100%;
  }

  .#{$prefix}__main-slot {
    margin-bottom: 0.12rem;
  }

  .#{$prefix}__header,
  .#{$prefix}__body {
    @include row;
    padding: 0 0.18rem;
  }

  .#{$prefix}__day-name,
  .#{$prefix}__day-number {
    @include columns(14, 2);
    @include padding-y(0.12rem);
  }

  .#{$prefix}__day-name {
    @include typography('b3', 'regular');
    text-align: center;

    color: map-get($colors, 'grey_40');
  }

  .#{$prefix}__day-number {
    @include typography('b1', 'bold');
    text-align: center;

    color: map-get($colors, 'grey_20');

    border-radius: 12px;

    &.active {
      cursor: pointer;
      color: map-get($colors, 'black');

      &:hover {
        background: map-get($colors, 'grey_4');
      }
    }

    &.no-active {
      color: map-get($colors, 'grey_20');
      cursor: not-allowed;

      &:hover {
        background: none;
      }
    }

    &.current {
      cursor: pointer;
      color: map-get($colors, 'default');
    }

    &.new {
      background: map-get($colors, 'default');
      color: map-get($colors, 'white');

      &:hover {
        background: map-get($colors, 'default');
      }
    }
  }

  .#{$prefix}__delivery-info {
    padding-bottom: 0.2rem;

    & .#{$prefix}__day-name,
    & .#{$prefix}__day-number {
      @include padding-y(0.07rem);
    }

    & .#{$prefix}__day-number {
      @include typography('b3', 'medium');
      border-radius: 4px;
      border: 1px solid rgba(map-get($colors, 'white'), 0);

      &.new {
        color: map-get($colors, 'black_0');
        background: map-get($colors, 'green_light');

        border: 1px solid map-get($colors, 'green_20');
        border-radius: 4px;

        box-sizing: border-box;
        box-shadow: 0 1px 4px rgba(map-get($colors, 'black_0'), 0.03);
      }

      &.current {
        color: map-get($colors, 'default');
        background: map-get($colors, 'green_5');

        border: 1px solid map-get($colors, 'default');
        border-radius: 4px;

        box-sizing: border-box;
        box-shadow: 0 2px 4px rgba(map-get($colors, 'default'), 0.05);
      }

      &.current-day {
        color: map-get($colors, 'default');
      }
    }
  }
</style>
